import { render, staticRenderFns } from "./PersonEventPicker.vue?vue&type=template&id=d801a2a4"
import script from "./PersonEventPicker.vue?vue&type=script&lang=js"
export * from "./PersonEventPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports